import { useRef, useState } from "react";
import "../../styles/components/video_grid.css";
import play from "../../assets/programs/play.svg";

const FellowVideoGrid = ({ videos }) => {
  const [playingVideo, setPlayingVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const S3_BUCKET_URL = process.env.REACT_APP_S3_IMAGES_BUCKET_URL;

  const videoRefs = useRef({});

  const handleVideoClick = (videoId) => {
    const currentVideo = videoRefs.current[videoId];

    if (playingVideo === videoId) {
      return;
    }

    if (currentVideo && currentVideo.paused) {
      currentVideo.play();
      setPlayingVideo(videoId);
      return;
    }

    if (playingVideo && videoRefs.current[playingVideo]) {
      videoRefs.current[playingVideo].pause();
    }

    setIsLoading(true);
    setPlayingVideo(videoId);
  };

  return (
    <div className="fellows-videos-grid">
      {videos.map((video, i) => (
        <div className="fellow-video-card" key={`video-${video.title}-${i}`}>
          {playingVideo === video.videoId ? (
            <>
              {isLoading && <div className="overlay loading">Loading...</div>}
              <video
                ref={(el) => (videoRefs.current[video.videoId] = el)}
                src={`${S3_BUCKET_URL}/videos/${video.videoId}.mp4`}
                controls
                autoPlay
                preload="auto"
                style={{ width: "100%", height: "100%" }}
                onLoadedData={() => setIsLoading(false)}
              />
            </>
          ) : (
            <>
              <img src={video.thumbnail} alt={video.title} />
              <div className="overlay"></div>
              <div
                className="video-detail"
                onClick={() => handleVideoClick(video.videoId)}
              >
                <span className="video-title">{video.title}</span>
                <img src={play} alt="play button" />
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default FellowVideoGrid;
